<h2 mat-dialog-title>
  {{ title }}
</h2>
<mat-dialog-content>
  <ng-container *ngFor="let warning of warnings">
    <glxy-alert class="alert-banner" [showClose]="false" [type]="'warning'">
      {{ warning | translate }}
    </glxy-alert>
  </ng-container>

  <glxy-form-field [prefixIcon]="'search'">
    <glxy-hint>{{ 'AUTOMATIONS.MANUAL_AUTOMATIONS.MODAL_INFO_V3' | translate }}</glxy-hint>
    <input
      type="text"
      matInput
      [formControl]="manualAutomationSearch"
      (input)="updateSearchTerm($event)"
      [placeholder]="'AUTOMATIONS.COMMON.SEARCH' | translate"
    />
    <glxy-loading-spinner
      class="loading-spinner"
      *ngIf="(loading$ | async) || starting"
      matSuffix
      size="small"
      [fullWidth]="false"
      [fullHeight]="false"
      [inline]="true"
    ></glxy-loading-spinner>
  </glxy-form-field>

  <div class="list-holder">
    <ng-container *ngIf="automations$ | async as autos">
      <glxy-form-field *ngIf="autos.length > 0">
        <mat-radio-group [(ngModel)]="selectedAutomation">
          <mat-radio-button *ngFor="let automation of autos" [value]="automation">
            {{ automation.name }}
            <extended>{{ automation.description }}</extended>
          </mat-radio-button>
        </mat-radio-group>
      </glxy-form-field>
      <ng-container *ngIf="autos.length === 0">
        <div class="no-automations">
          {{ 'AUTOMATIONS.MANUAL_AUTOMATIONS.NO_MATCHING_AUTOMATIONS' | translate }}
        </div>
      </ng-container>
    </ng-container>
    <glxy-infinite-scroll-trigger
      [visiblilityMargin]="120"
      (isVisible)="loadMoreAutomations()"
    ></glxy-infinite-scroll-trigger>
  </div>
</mat-dialog-content>

<mat-dialog-actions mat-dialog-actions class="dialog-actions">
  <button *ngIf="!hideSettingsLink" mat-button color="primary" tabindex="-1" (click)="goToSettings()">
    {{ 'AUTOMATIONS.MANUAL_AUTOMATIONS.GO_TO_PAGE' | translate }}
  </button>
  <div>
    <button mat-stroked-button class="cancel" color="primary" (click)="emitClose()">
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button
      mat-flat-button
      class="cancel"
      color="primary"
      (click)="start()"
      [disabled]="!selectedAutomation"
      [glxyTooltip]="
        'AUTOMATIONS.MANUAL_AUTOMATIONS.START_SPECIFIC_AUTOMATION' | translate : { name: selectedAutomation?.name }
      "
    >
      <ng-container *ngIf="onlySelectDontStart">{{ 'AUTOMATIONS.SELECT' | translate }}</ng-container>
      <ng-container *ngIf="!onlySelectDontStart">{{ 'COMMON.ACTION_LABELS.START' | translate }}</ng-container>
    </button>
  </div>
</mat-dialog-actions>
